import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import { StyledTextDiv } from '../../utils/reportUsage.styled';
import AlertMsg from '../AlertMsg';
import { useTranslation } from 'react-i18next';

const TextWithInputs = ({
    xs,
    styleObj,
    value,
    onkeyUp,
    name,
    topLabel,
    bottomLabel,
    bottomLabelFontSize,
    bottomLabelFontFamily,
    bottomFontWeight,
    width,
    paddingLeft,
    placeholder,
    lg,
    cursor,
    md,
    sm,
    onLabelClick,
    maxLength,
    inputWidth,
    inputHeight,
    inputDisabled,
    inputBorder,
    defaultValue,
    alignText,
    isBundleItem,
    errorMsg,
    marginLeft,
    inputMarginLeft,
    errorMessageMaxWidth,
    marginTop,
    autoFocus,
    showError = true,
    marginBottom,
    float,
    errorMessages,
    onBlurEvent,
    errorMessageWidth,
    vendorCaseErrorRedirection,
    linkedSstref,
    position,
    noItemInBundleErr,
    lotSerial,
}) => {
    const { t } = useTranslation();
    return (
        <Grid item xs={xs} lg={lg} md={md} sm={sm} style={styleObj}>
            <div
                style={{
                    width: width ? width : '100%',
                    paddingLeft: paddingLeft ? paddingLeft : '0px',
                    marginLeft: marginLeft,
                    marginTop: marginTop,
                    marginBottom: marginBottom,
                }}
            >
                {topLabel && (
                    <CustomLabel
                        fSize={'12px!important'}
                        color="#140F4B"
                        opacity="70%"
                        label={topLabel}
                        textAlign={alignText}
                        marginLeft={marginLeft}
                    />
                )}
                {isBundleItem ? (
                    <>
                        <StyledTextDiv
                            opacity={1}
                            fontFamily="AvenirNextWorld Regular"
                            color="#202124"
                            fontSize={'13px'}
                            padding={'10px 0 0'}
                        >
                            {t(
                                'reportUsage.common.textWithInputs.notApplicable'
                            )}
                        </StyledTextDiv>
                    </>
                ) : (
                    <>
                        <input
                            id={`input-${name}`}
                            autoComplete="off"
                            placeholder={placeholder}
                            disabled={inputDisabled}
                            autoFocus={autoFocus}
                            style={{
                                width: inputWidth ? inputWidth : '100%',
                                height: inputHeight,
                            border: inputBorder
                                ? inputBorder
                                : '1.5px solid #EBEDED',
                            padding: '6px 8px',
                            borderRadius: 6,
                                outline: 'none',
                                background: inputDisabled
                                    ? '#F1F1F1 0% 0% no-repeat padding-box'
                                    : '#FFFFFF 0% 0% no-repeat padding-box',
                                color: '#202124',
                                opacity: inputDisabled ? 0.6 : 1,
                                fontFamily: 'AvenirNextWorld Regular',
                                textAlign: alignText,
                                marginLeft: inputMarginLeft,
                                fontSize: '15px',
                                float: float,
                                autoComplete: 'off',
                            }}
                            onBlur={
                                onBlurEvent
                                    ? onBlurEvent
                                    : !maxLength
                                    ? onkeyUp
                                    : undefined
                            }
                            name={name}
                            value={value}
                            maxLength={maxLength}
                            onChange={maxLength ? onkeyUp : lotSerial ? onkeyUp : undefined}
                            defaultValue={defaultValue}
                        />
                        {errorMsg && showError && (
                            <div
                                style={{
                                    display: 'flex',
                                    width: 'max-content',
                                    paddingTop: '7px',
                                    maxWidth: errorMessageMaxWidth,
                                }}
                            >
                                <AlertMsg message={errorMsg} isReplenish={true}/>
                            </div>
                        )}
                    </>
                )}
                {/* errMsg[0] => Qty, errMsg[1] => Lot/Serial */}
                {errorMessages?.length > 0 &&
                    errorMessages.map((errMsg) =>
                        errMsg ? (
                            <ErrorMsgContainer
                                errorMessageWidth={errorMessageWidth}
                                position={position}
                            >
                                <AlertMsg
                                    message={errMsg}
                                    linkedSstref={linkedSstref}
                                    vendorCaseErrorRedirection={
                                        vendorCaseErrorRedirection
                                    }
                                    lotSerial={value || defaultValue}
                                />
                            </ErrorMsgContainer>
                        ) : null
                    )}

                {bottomLabel && (
                    <CustomLabel
                        fSize={
                            bottomLabelFontSize
                                ? bottomLabelFontSize
                                : '12px!important'
                        }
                        fontFamily={bottomLabelFontFamily}
                        color="#1010EB"
                        cursor={cursor}
                        opacity={1}
                        label={bottomLabel}
                        onLabelClick={onLabelClick}
                        paddingTop={'10px'}
                        letterSpacing={'-0.11px'}
                        fWeight={bottomFontWeight}
                    />
                )}
                {noItemInBundleErr ===
                t('reportUsage.itemTableErrorMessages.Bundle') ? (
                    <ErrorMsgContainer
                        errorMessageWidth={errorMessageWidth}
                        position={position}
                        paddingTop={'5px'}
                    >
                        <AlertMsg message={noItemInBundleErr} />
                    </ErrorMsgContainer>
                ) : null}
            </div>
        </Grid>
    );
};

export default TextWithInputs;

const ErrorMsgContainer = styled.div`
    display: flex;
    width: ${(props) =>
        props.errorMessageWidth ? props.errorMessageWidth : 'max-content'};
    padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '7px')};
    position: ${(props) => props.position};
`;
